// Logica condivisa tra PrenotazioniDesktop e PrenotazioniMobile.
// Gestisce unicamente la lista: tab attivo, ricerca, caricamento archivio on-demand.
export default {
  data() {
    return {
      tab: 0,              // 0 = Attive, 1 = Archivio
      search: "",
      archivio_loaded: false,
      archivio_loading: false,
    };
  },

  computed: {
    prenotazioni_attive() {
      return this.$store.getters["prenotazioni/attive"];
    },

    prenotazioni_archivio() {
      return this.$store.getters["prenotazioni/archivio"];
    },

    attive_filtrate() {
      if (!this.search.trim()) return this.prenotazioni_attive;
      const q = this.search.toLowerCase();
      return this.prenotazioni_attive.filter(
        (p) =>
          p.cliente.toLowerCase().includes(q) ||
          p.iva.includes(q)
      );
    },

    archivio_filtrato() {
      if (!this.search.trim()) return this.prenotazioni_archivio;
      const q = this.search.toLowerCase();
      return this.prenotazioni_archivio.filter(
        (p) =>
          p.cliente.toLowerCase().includes(q) ||
          p.iva.includes(q)
      );
    },
  },

  watch: {
    tab(val) {
      if (val === 1 && !this.archivio_loaded) {
        this.load_archivio();
      }
    },
  },

  methods: {
    async load_archivio() {
      this.archivio_loading = true;
      try {
        await this.$store.dispatch("prenotazioni/fetch_archivio");
        this.archivio_loaded = true;
      } finally {
        this.archivio_loading = false;
      }
    },
  },
};
